import { LIST_ALL_BUSINESS_TRANSACTIONS, RESET_TRANSACTIONS_DATA, LIST_ALL_WALLET_TRANSACTIONS } from "../types";

const INITIAL_STATE = {
    list: [],
    showViewMore: false,
    pageNumber: 1,
    pageSize: 10,
    txnDetails: {},
};

const transactionsReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case LIST_ALL_BUSINESS_TRANSACTIONS:
            const data = { pageSize: 10, ...payload };
            return {
                ...state,
                ...data,
            };

        case LIST_ALL_WALLET_TRANSACTIONS:
            const data1 = { pageSize: 10, ...payload };
            return {
                ...state,
                ...data1,
            };

        case RESET_TRANSACTIONS_DATA:
            return INITIAL_STATE;

        default:
            return state;
    }
};

export default transactionsReducer;
